export const GET_STAFF_SALARY = 'GET_STAFF_SALARY';
export const GET_STAFF_SALARY_SUCCESS = 'GET_STAFF_SALARY_SUCCESS';
export const GET_STAFF_SALARY_FAIL = 'GET_STAFF_SALARY_FAIL';